import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'https://skymuse.in/api';

export const API_BASE_ORIGIN = API_URL.replace(/\/api\/?$/, '');

// resolve a stored image path (/uploads/...) to a full URL served via the API proxy
export const resolveImageUrl = (p) =>
  !p ? '' : p.startsWith('http') || p.startsWith('data:') ? p : `${API_URL}${p}`;

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

export const fetchContactInfo = async () => {
  const { data } = await api.get('/contact');
  return data;
};

export const fetchPortfolio = async (params = {}) => {
  const { data } = await api.get('/portfolio', { params });
  return data;
};

export const fetchWebsiteContent = async () => {
  const { data } = await api.get('/content');
  return data;
};

export const fetchSettings = async () => {
  const { data } = await api.get('/settings');
  return data;
};

export const submitLead = async (leadData) => {
  const { data } = await api.post('/leads', leadData);
  return data;
};

export default api;
